import { StoreLocationItem } from 'cdfdigital-common/build/models';
import { MouseEventHandler } from 'react';
import { Coordinates } from '.';
import { MarkerProps } from './Marker';

interface IActiveMarker extends MarkerProps {
  marker: StoreLocationItem;
  closeAction?: MouseEventHandler<any>;
}

const ActiveMarker: React.FC<IActiveMarker> = ({
  icon,
  marker,
  closeAction,
}) => {
  const getMapLink = ({ latitude, longitude }: Coordinates) => {
    return `https://www.google.com/maps/dir/?destination=${latitude},${longitude}&travelmode=driving&api=1`;
  };

  return (
    <div className="marker-active">
      <div className="close" onClick={closeAction}>
        X
      </div>
      <a
        className="location-label"
        href={getMapLink({
          latitude: marker.location.coordinates[1],
          longitude: marker.location.coordinates[0],
        })}
        target="_blank"
        rel="noreferrer"
      >
        <div className="label-title">{marker.name}</div>
        <div className="label-title">{marker.address}</div>
        <div>CEP: {marker.zip}</div>
        <div>Tel.: {marker.phone}</div>
        <div className="label-link">Como chegar</div>
      </a>
    </div>
  );
};

export default ActiveMarker;
